export default __webpack_public_path__ + "static/media/PPI-patio-015.3322ee03.jpg";